module.exports = __webpack_public_path__ + "img/defaultdec_en_US.c994cb27.png";